import { Components } from "@thisgorilla/primate-ds";
import { styled, useTheme } from "styled-components";
import { FlexRow } from "../Styles";

type GradientCardProps = {
  text: string;
  selected: boolean;
  onClick: () => void;
  background: string;
};

const GradientCard = ({
  background,
  text,
  selected,
  onClick,
}: GradientCardProps) => {
  const { typography } = useTheme();
  return (
    <Container $selected={selected} onClick={onClick}>
      <Circle $background={background} />
      <Components.Text
        text={text}
        style={{ tokenStyle: typography.Body.M }}
        lineHeight="line-height-100"
      />
    </Container>
  );
};

export default GradientCard;

const Container = styled(FlexRow)<{ $selected: boolean }>`
  cursor: pointer;
  align-items: center;
  height: ${({ theme }) => theme.spacing["spacing-9"].value}rem;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background-color: ${({ theme, $selected }) =>
    theme.Color.elevation.surface[
      $selected ? "surface-primary-emphasize-hover" : "surface-primary"
    ].value};
  &:hover {
    background-color: ${({ theme }) =>
      theme.Color.elevation.surface["surface-primary-hover"].value};
  }
`;

const Circle = styled.div<{ $background: string }>`
  width: ${({ theme }) => theme.spacing["spacing-7"].value}rem;
  height: ${({ theme }) => theme.spacing["spacing-7"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-full-round"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: ${({ $background }) => $background};
`;
